import classNames from 'classnames';
import React from 'react';
import Shortcut from './Shortcut';
import * as styles from './ShortcutRow.module.scss';

interface ShortcutRowProps {
  children?: React.ReactNode;
  name: React.ReactNode;
  keys?: string;
  input?: string;
  post?: boolean;
}

const ShortcutRow = ({
  children,
  name,
  keys,
  post,
  input,
}: ShortcutRowProps) => (
  <tr>
    <td
      className={classNames(styles.shortcutName, {
        'post-typography': post,
      })}
    >
      {name}
    </td>
    <td className={styles.shortcut}>
      {children || <Shortcut input={input} keys={keys} />}
    </td>
  </tr>
);

export default ShortcutRow;
